import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_COMMUNITIES } from "./apiRoutes";

interface UseGetCommunityReviewProps {
  community_id: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getCommunityReview = async (ID: string) =>
  await axiosAuth.get(`${GET_COMMUNITIES}/${ID}/review`);

const useGetCommunityReview = ({
  community_id,
  queryParams,
}: UseGetCommunityReviewProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["community", community_id],
    queryFn: () => getCommunityReview(community_id),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!community_id && (queryParams?.enabled ?? true),
  });
};

export default useGetCommunityReview;
